module.exports = __webpack_public_path__ + "static/img/weixin.f0c2089.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/weixin.jpg
// module id = 5M8D
// module chunks = 1